import { render, staticRenderFns } from "./PruchaseInvocies.vue?vue&type=template&id=646a4cae&scoped=true&"
import script from "./PruchaseInvocies.vue?vue&type=script&lang=js&"
export * from "./PruchaseInvocies.vue?vue&type=script&lang=js&"
import style0 from "./PruchaseInvocies.vue?vue&type=style&index=0&id=646a4cae&prod&lang=scss&scoped=true&"
import style1 from "./PruchaseInvocies.vue?vue&type=style&index=1&id=646a4cae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646a4cae",
  null
  
)

export default component.exports